// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event from "./buhta_payroll_hrm_v1alpha1_employment_event.js";
import * as Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event_data from "./buhta_payroll_hrm_v1alpha1_employment_event_data.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetEmploymentEventRequest = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_service.ml",
      1244,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetEmploymentEventResponse = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_service.ml",
      1310,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListEmploymentEventsRequest = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_service.ml",
      1371,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListEmploymentEventsResponse = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_service.ml",
      1434,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateEmploymentEventRequest = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_service.ml",
      1495,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateEmploymentEventResponse = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_service.ml",
      1558,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateEmploymentEventRequest = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_service.ml",
      1620,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateEmploymentEventResponse = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_service.ml",
      1686,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.payroll.hrm.v1alpha1.GetEmploymentEventRequest";
}

function make(employee_idOpt, idOpt, expandOpt, param) {
  const employee_id = employee_idOpt !== undefined ? employee_idOpt : "";
  const id = idOpt !== undefined ? idOpt : "";
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          employee_id: employee_id,
          id: id,
          expand: expand
        };
}

const merge_employee_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "employee_id",
            "employeeId"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            3,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          employee_id: Curry._2(merge_employee_id, t1.employee_id, t2.employee_id),
          id: Curry._2(merge_id, t1.id, t2.id),
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "employee_id",
                    "employeeId"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "id",
                        "id"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                          [
                            3,
                            "expand",
                            "expand"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          Ocaml_protoc_plugin__Spec.not_packed
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._4(serialize, writer, param.employee_id, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(employee_id, id, expand) {
  return {
          employee_id: employee_id,
          id: id,
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.GetEmploymentEventRequest", spec(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.employee_id, param.id, param.expand);
  };
}

function constructor$1(employee_id, id, expand) {
  return {
          employee_id: employee_id,
          id: id,
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.GetEmploymentEventRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetEmploymentEventRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.payroll.hrm.v1alpha1.GetEmploymentEventResponse";
}

function make$1($$event, param) {
  return {
          event: $$event
        };
}

const $$let = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event.Buhta.Payroll.Hrm.V1alpha1.EmploymentEvent;

const merge_event = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "event",
            "event"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          event: Curry._2(merge_event, t1.event, t2.event)
        };
}

function spec$1(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event.Buhta.Payroll.Hrm.V1alpha1.EmploymentEvent;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "event",
                    "event"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.event);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2($$event) {
  return {
          event: $$event
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.GetEmploymentEventResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.event);
  };
}

function constructor$3($$event) {
  return {
          event: $$event
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.GetEmploymentEventResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetEmploymentEventResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.payroll.hrm.v1alpha1.ListEmploymentEventsRequest";
}

function make$2(employee_id, grid, param) {
  return {
          employee_id: employee_id,
          grid: grid
        };
}

const merge_employee_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "employee_id",
            "employeeId"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "grid",
            "grid"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          employee_id: Curry._2(merge_employee_id$1, t1.employee_id, t2.employee_id),
          grid: Curry._2(merge_grid, t1.grid, t2.grid)
        };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "employee_id",
                    "employeeId"
                  ],
                  Ocaml_protoc_plugin__Spec.string
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "grid",
                        "grid"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let.name,
                            make: $$let.make,
                            from_proto: $$let.from_proto,
                            from_proto_exn: $$let.from_proto_exn,
                            to_proto: $$let.to_proto,
                            to_proto$p: $$let.to_proto$p,
                            merge: $$let.merge,
                            to_json: $$let.to_json,
                            from_json_exn: $$let.from_json_exn,
                            from_json: $$let.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.employee_id, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(employee_id, grid) {
  return {
          employee_id: employee_id,
          grid: grid
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.ListEmploymentEventsRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.employee_id, param.grid);
  };
}

function constructor$5(employee_id, grid) {
  return {
          employee_id: employee_id,
          grid: grid
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.ListEmploymentEventsRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListEmploymentEventsRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.payroll.hrm.v1alpha1.ListEmploymentEventsResponse";
}

function make$3(eventsOpt, param) {
  const events = eventsOpt !== undefined ? eventsOpt : /* [] */0;
  return {
          events: events
        };
}

const $$let$2 = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event.Buhta.Payroll.Hrm.V1alpha1.EmploymentEvent;

const merge_events = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "events",
            "events"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$3(t1, t2) {
  return {
          events: Curry._2(merge_events, t1.events, t2.events)
        };
}

function spec$3(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event.Buhta.Payroll.Hrm.V1alpha1.EmploymentEvent;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "events",
                    "events"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.events);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(events) {
  return {
          events: events
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.ListEmploymentEventsResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.events);
  };
}

function constructor$7(events) {
  return {
          events: events
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.ListEmploymentEventsResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListEmploymentEventsResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

function name$4(param) {
  return ".buhta.payroll.hrm.v1alpha1.CreateEmploymentEventRequest";
}

function make$4(employee_idOpt, $$event, param) {
  const employee_id = employee_idOpt !== undefined ? employee_idOpt : "";
  return {
          employee_id: employee_id,
          event: $$event
        };
}

const merge_employee_id$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "employee_id",
            "employeeId"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$3 = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event_data.Buhta.Payroll.Hrm.V1alpha1.EmploymentEventData;

const merge_event$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "event",
            "event"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

function merge$4(t1, t2) {
  return {
          employee_id: Curry._2(merge_employee_id$2, t1.employee_id, t2.employee_id),
          event: Curry._2(merge_event$1, t1.event, t2.event)
        };
}

function spec$4(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event_data.Buhta.Payroll.Hrm.V1alpha1.EmploymentEventData;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "employee_id",
                    "employeeId"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "event",
                        "event"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let.name,
                            make: $$let.make,
                            from_proto: $$let.from_proto,
                            from_proto_exn: $$let.from_proto_exn,
                            to_proto: $$let.to_proto,
                            to_proto$p: $$let.to_proto$p,
                            merge: $$let.merge,
                            to_json: $$let.to_json,
                            from_json_exn: $$let.from_json_exn,
                            from_json: $$let.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry._3(serialize$4, writer, param.employee_id, param.event);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(employee_id, $$event) {
  return {
          employee_id: employee_id,
          event: $$event
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.CreateEmploymentEventRequest", spec$4(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.employee_id, param.event);
  };
}

function constructor$9(employee_id, $$event) {
  return {
          employee_id: employee_id,
          event: $$event
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.CreateEmploymentEventRequest", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateEmploymentEventRequest, {
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$4,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

function name$5(param) {
  return ".buhta.payroll.hrm.v1alpha1.CreateEmploymentEventResponse";
}

function make$5($$event, param) {
  return {
          event: $$event
        };
}

const $$let$4 = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event.Buhta.Payroll.Hrm.V1alpha1.EmploymentEvent;

const merge_event$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "event",
            "event"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

function merge$5(t1, t2) {
  return {
          event: Curry._2(merge_event$2, t1.event, t2.event)
        };
}

function spec$5(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event.Buhta.Payroll.Hrm.V1alpha1.EmploymentEvent;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "event",
                    "event"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
    });

function to_proto$p$5(writer, param) {
  Curry._2(serialize$5, writer, param.event);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10($$event) {
  return {
          event: $$event
        };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
    });

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$5, writer);
            });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.CreateEmploymentEventResponse", spec$5(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.event);
  };
}

function constructor$11($$event) {
  return {
          event: $$event
        };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.CreateEmploymentEventResponse", spec$5(undefined), constructor$11);
    });

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$5, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateEmploymentEventResponse, {
      make: make$5,
      to_proto: to_proto$5,
      from_proto: from_proto$5,
      to_json: to_json$5,
      from_json: from_json$5,
      name: name$5,
      merge: merge$5,
      to_proto$p: to_proto$p$5,
      from_proto_exn: from_proto_exn$5,
      from_json_exn: from_json_exn$5
    });

function name$6(param) {
  return ".buhta.payroll.hrm.v1alpha1.UpdateEmploymentEventRequest";
}

function make$6(employee_idOpt, idOpt, $$event, param) {
  const employee_id = employee_idOpt !== undefined ? employee_idOpt : "";
  const id = idOpt !== undefined ? idOpt : "";
  return {
          employee_id: employee_id,
          id: id,
          event: $$event
        };
}

const merge_employee_id$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "employee_id",
            "employeeId"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$5 = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event_data.Buhta.Payroll.Hrm.V1alpha1.EmploymentEventData;

const merge_event$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            3,
            "event",
            "event"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$5.name,
                make: $$let$5.make,
                from_proto: $$let$5.from_proto,
                from_proto_exn: $$let$5.from_proto_exn,
                to_proto: $$let$5.to_proto,
                to_proto$p: $$let$5.to_proto$p,
                merge: $$let$5.merge,
                to_json: $$let$5.to_json,
                from_json_exn: $$let$5.from_json_exn,
                from_json: $$let$5.from_json
              })
        ]));

function merge$6(t1, t2) {
  return {
          employee_id: Curry._2(merge_employee_id$3, t1.employee_id, t2.employee_id),
          id: Curry._2(merge_id$1, t1.id, t2.id),
          event: Curry._2(merge_event$3, t1.event, t2.event)
        };
}

function spec$6(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event_data.Buhta.Payroll.Hrm.V1alpha1.EmploymentEventData;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "employee_id",
                    "employeeId"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "id",
                        "id"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                          [
                            3,
                            "event",
                            "event"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                                name: $$let.name,
                                make: $$let.make,
                                from_proto: $$let.from_proto,
                                from_proto_exn: $$let.from_proto_exn,
                                to_proto: $$let.to_proto,
                                to_proto$p: $$let.to_proto$p,
                                merge: $$let.merge,
                                to_json: $$let.to_json,
                                from_json_exn: $$let.from_json_exn,
                                from_json: $$let.from_json
                              })
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
    });

function to_proto$p$6(writer, param) {
  Curry._4(serialize$6, writer, param.employee_id, param.id, param.event);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(employee_id, id, $$event) {
  return {
          employee_id: employee_id,
          id: id,
          event: $$event
        };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
    });

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$6, writer);
            });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.UpdateEmploymentEventRequest", spec$6(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.employee_id, param.id, param.event);
  };
}

function constructor$13(employee_id, id, $$event) {
  return {
          employee_id: employee_id,
          id: id,
          event: $$event
        };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.UpdateEmploymentEventRequest", spec$6(undefined), constructor$13);
    });

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$6, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateEmploymentEventRequest, {
      make: make$6,
      to_proto: to_proto$6,
      from_proto: from_proto$6,
      to_json: to_json$6,
      from_json: from_json$6,
      name: name$6,
      merge: merge$6,
      to_proto$p: to_proto$p$6,
      from_proto_exn: from_proto_exn$6,
      from_json_exn: from_json_exn$6
    });

function name$7(param) {
  return ".buhta.payroll.hrm.v1alpha1.UpdateEmploymentEventResponse";
}

function make$7($$event, param) {
  return {
          event: $$event
        };
}

const $$let$6 = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event.Buhta.Payroll.Hrm.V1alpha1.EmploymentEvent;

const merge_event$4 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "event",
            "event"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$6.name,
                make: $$let$6.make,
                from_proto: $$let$6.from_proto,
                from_proto_exn: $$let$6.from_proto_exn,
                to_proto: $$let$6.to_proto,
                to_proto$p: $$let$6.to_proto$p,
                merge: $$let$6.merge,
                to_json: $$let$6.to_json,
                from_json_exn: $$let$6.from_json_exn,
                from_json: $$let$6.from_json
              })
        ]));

function merge$7(t1, t2) {
  return {
          event: Curry._2(merge_event$4, t1.event, t2.event)
        };
}

function spec$7(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event.Buhta.Payroll.Hrm.V1alpha1.EmploymentEvent;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "event",
                    "event"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
    });

function to_proto$p$7(writer, param) {
  Curry._2(serialize$7, writer, param.event);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14($$event) {
  return {
          event: $$event
        };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
    });

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$7, writer);
            });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.UpdateEmploymentEventResponse", spec$7(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.event);
  };
}

function constructor$15($$event) {
  return {
          event: $$event
        };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.UpdateEmploymentEventResponse", spec$7(undefined), constructor$15);
    });

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$7, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateEmploymentEventResponse, {
      make: make$7,
      to_proto: to_proto$7,
      from_proto: from_proto$7,
      to_json: to_json$7,
      from_json: from_json$7,
      name: name$7,
      merge: merge$7,
      to_proto$p: to_proto$p$7,
      from_proto_exn: from_proto_exn$7,
      from_json_exn: from_json_exn$7
    });

const getEmploymentEvent_0 = {
  name: GetEmploymentEventRequest.name,
  make: GetEmploymentEventRequest.make,
  from_proto: GetEmploymentEventRequest.from_proto,
  from_proto_exn: GetEmploymentEventRequest.from_proto_exn,
  to_proto: GetEmploymentEventRequest.to_proto,
  to_proto$p: GetEmploymentEventRequest.to_proto$p,
  merge: GetEmploymentEventRequest.merge,
  to_json: GetEmploymentEventRequest.to_json,
  from_json_exn: GetEmploymentEventRequest.from_json_exn,
  from_json: GetEmploymentEventRequest.from_json
};

const getEmploymentEvent_1 = {
  name: GetEmploymentEventResponse.name,
  make: GetEmploymentEventResponse.make,
  from_proto: GetEmploymentEventResponse.from_proto,
  from_proto_exn: GetEmploymentEventResponse.from_proto_exn,
  to_proto: GetEmploymentEventResponse.to_proto,
  to_proto$p: GetEmploymentEventResponse.to_proto$p,
  merge: GetEmploymentEventResponse.merge,
  to_json: GetEmploymentEventResponse.to_json,
  from_json_exn: GetEmploymentEventResponse.from_json_exn,
  from_json: GetEmploymentEventResponse.from_json
};

const getEmploymentEvent = [
  getEmploymentEvent_0,
  getEmploymentEvent_1
];

const listEmploymentEvents_0 = {
  name: ListEmploymentEventsRequest.name,
  make: ListEmploymentEventsRequest.make,
  from_proto: ListEmploymentEventsRequest.from_proto,
  from_proto_exn: ListEmploymentEventsRequest.from_proto_exn,
  to_proto: ListEmploymentEventsRequest.to_proto,
  to_proto$p: ListEmploymentEventsRequest.to_proto$p,
  merge: ListEmploymentEventsRequest.merge,
  to_json: ListEmploymentEventsRequest.to_json,
  from_json_exn: ListEmploymentEventsRequest.from_json_exn,
  from_json: ListEmploymentEventsRequest.from_json
};

const listEmploymentEvents_1 = {
  name: ListEmploymentEventsResponse.name,
  make: ListEmploymentEventsResponse.make,
  from_proto: ListEmploymentEventsResponse.from_proto,
  from_proto_exn: ListEmploymentEventsResponse.from_proto_exn,
  to_proto: ListEmploymentEventsResponse.to_proto,
  to_proto$p: ListEmploymentEventsResponse.to_proto$p,
  merge: ListEmploymentEventsResponse.merge,
  to_json: ListEmploymentEventsResponse.to_json,
  from_json_exn: ListEmploymentEventsResponse.from_json_exn,
  from_json: ListEmploymentEventsResponse.from_json
};

const listEmploymentEvents = [
  listEmploymentEvents_0,
  listEmploymentEvents_1
];

const createEmploymentEvent_0 = {
  name: CreateEmploymentEventRequest.name,
  make: CreateEmploymentEventRequest.make,
  from_proto: CreateEmploymentEventRequest.from_proto,
  from_proto_exn: CreateEmploymentEventRequest.from_proto_exn,
  to_proto: CreateEmploymentEventRequest.to_proto,
  to_proto$p: CreateEmploymentEventRequest.to_proto$p,
  merge: CreateEmploymentEventRequest.merge,
  to_json: CreateEmploymentEventRequest.to_json,
  from_json_exn: CreateEmploymentEventRequest.from_json_exn,
  from_json: CreateEmploymentEventRequest.from_json
};

const createEmploymentEvent_1 = {
  name: CreateEmploymentEventResponse.name,
  make: CreateEmploymentEventResponse.make,
  from_proto: CreateEmploymentEventResponse.from_proto,
  from_proto_exn: CreateEmploymentEventResponse.from_proto_exn,
  to_proto: CreateEmploymentEventResponse.to_proto,
  to_proto$p: CreateEmploymentEventResponse.to_proto$p,
  merge: CreateEmploymentEventResponse.merge,
  to_json: CreateEmploymentEventResponse.to_json,
  from_json_exn: CreateEmploymentEventResponse.from_json_exn,
  from_json: CreateEmploymentEventResponse.from_json
};

const createEmploymentEvent = [
  createEmploymentEvent_0,
  createEmploymentEvent_1
];

const updateEmploymentEvent_0 = {
  name: UpdateEmploymentEventRequest.name,
  make: UpdateEmploymentEventRequest.make,
  from_proto: UpdateEmploymentEventRequest.from_proto,
  from_proto_exn: UpdateEmploymentEventRequest.from_proto_exn,
  to_proto: UpdateEmploymentEventRequest.to_proto,
  to_proto$p: UpdateEmploymentEventRequest.to_proto$p,
  merge: UpdateEmploymentEventRequest.merge,
  to_json: UpdateEmploymentEventRequest.to_json,
  from_json_exn: UpdateEmploymentEventRequest.from_json_exn,
  from_json: UpdateEmploymentEventRequest.from_json
};

const updateEmploymentEvent_1 = {
  name: UpdateEmploymentEventResponse.name,
  make: UpdateEmploymentEventResponse.make,
  from_proto: UpdateEmploymentEventResponse.from_proto,
  from_proto_exn: UpdateEmploymentEventResponse.from_proto_exn,
  to_proto: UpdateEmploymentEventResponse.to_proto,
  to_proto$p: UpdateEmploymentEventResponse.to_proto$p,
  merge: UpdateEmploymentEventResponse.merge,
  to_json: UpdateEmploymentEventResponse.to_json,
  from_json_exn: UpdateEmploymentEventResponse.from_json_exn,
  from_json: UpdateEmploymentEventResponse.from_json
};

const updateEmploymentEvent = [
  updateEmploymentEvent_0,
  updateEmploymentEvent_1
];

const V1alpha1_EmploymentService = {
  GetEmploymentEvent: {
    name: "/buhta.payroll.hrm.v1alpha1.EmploymentService/GetEmploymentEvent",
    package_name: "buhta.payroll.hrm.v1alpha1",
    service_name: "EmploymentService",
    method_name: "GetEmploymentEvent",
    $$Request: {
      name: GetEmploymentEventRequest.name,
      make: GetEmploymentEventRequest.make,
      from_proto: GetEmploymentEventRequest.from_proto,
      from_proto_exn: GetEmploymentEventRequest.from_proto_exn,
      to_proto: GetEmploymentEventRequest.to_proto,
      to_proto$p: GetEmploymentEventRequest.to_proto$p,
      merge: GetEmploymentEventRequest.merge,
      to_json: GetEmploymentEventRequest.to_json,
      from_json_exn: GetEmploymentEventRequest.from_json_exn,
      from_json: GetEmploymentEventRequest.from_json
    },
    $$Response: {
      name: GetEmploymentEventResponse.name,
      make: GetEmploymentEventResponse.make,
      from_proto: GetEmploymentEventResponse.from_proto,
      from_proto_exn: GetEmploymentEventResponse.from_proto_exn,
      to_proto: GetEmploymentEventResponse.to_proto,
      to_proto$p: GetEmploymentEventResponse.to_proto$p,
      merge: GetEmploymentEventResponse.merge,
      to_json: GetEmploymentEventResponse.to_json,
      from_json_exn: GetEmploymentEventResponse.from_json_exn,
      from_json: GetEmploymentEventResponse.from_json
    }
  },
  getEmploymentEvent: getEmploymentEvent,
  ListEmploymentEvents: {
    name: "/buhta.payroll.hrm.v1alpha1.EmploymentService/ListEmploymentEvents",
    package_name: "buhta.payroll.hrm.v1alpha1",
    service_name: "EmploymentService",
    method_name: "ListEmploymentEvents",
    $$Request: {
      name: ListEmploymentEventsRequest.name,
      make: ListEmploymentEventsRequest.make,
      from_proto: ListEmploymentEventsRequest.from_proto,
      from_proto_exn: ListEmploymentEventsRequest.from_proto_exn,
      to_proto: ListEmploymentEventsRequest.to_proto,
      to_proto$p: ListEmploymentEventsRequest.to_proto$p,
      merge: ListEmploymentEventsRequest.merge,
      to_json: ListEmploymentEventsRequest.to_json,
      from_json_exn: ListEmploymentEventsRequest.from_json_exn,
      from_json: ListEmploymentEventsRequest.from_json
    },
    $$Response: {
      name: ListEmploymentEventsResponse.name,
      make: ListEmploymentEventsResponse.make,
      from_proto: ListEmploymentEventsResponse.from_proto,
      from_proto_exn: ListEmploymentEventsResponse.from_proto_exn,
      to_proto: ListEmploymentEventsResponse.to_proto,
      to_proto$p: ListEmploymentEventsResponse.to_proto$p,
      merge: ListEmploymentEventsResponse.merge,
      to_json: ListEmploymentEventsResponse.to_json,
      from_json_exn: ListEmploymentEventsResponse.from_json_exn,
      from_json: ListEmploymentEventsResponse.from_json
    }
  },
  listEmploymentEvents: listEmploymentEvents,
  CreateEmploymentEvent: {
    name: "/buhta.payroll.hrm.v1alpha1.EmploymentService/CreateEmploymentEvent",
    package_name: "buhta.payroll.hrm.v1alpha1",
    service_name: "EmploymentService",
    method_name: "CreateEmploymentEvent",
    $$Request: {
      name: CreateEmploymentEventRequest.name,
      make: CreateEmploymentEventRequest.make,
      from_proto: CreateEmploymentEventRequest.from_proto,
      from_proto_exn: CreateEmploymentEventRequest.from_proto_exn,
      to_proto: CreateEmploymentEventRequest.to_proto,
      to_proto$p: CreateEmploymentEventRequest.to_proto$p,
      merge: CreateEmploymentEventRequest.merge,
      to_json: CreateEmploymentEventRequest.to_json,
      from_json_exn: CreateEmploymentEventRequest.from_json_exn,
      from_json: CreateEmploymentEventRequest.from_json
    },
    $$Response: {
      name: CreateEmploymentEventResponse.name,
      make: CreateEmploymentEventResponse.make,
      from_proto: CreateEmploymentEventResponse.from_proto,
      from_proto_exn: CreateEmploymentEventResponse.from_proto_exn,
      to_proto: CreateEmploymentEventResponse.to_proto,
      to_proto$p: CreateEmploymentEventResponse.to_proto$p,
      merge: CreateEmploymentEventResponse.merge,
      to_json: CreateEmploymentEventResponse.to_json,
      from_json_exn: CreateEmploymentEventResponse.from_json_exn,
      from_json: CreateEmploymentEventResponse.from_json
    }
  },
  createEmploymentEvent: createEmploymentEvent,
  UpdateEmploymentEvent: {
    name: "/buhta.payroll.hrm.v1alpha1.EmploymentService/UpdateEmploymentEvent",
    package_name: "buhta.payroll.hrm.v1alpha1",
    service_name: "EmploymentService",
    method_name: "UpdateEmploymentEvent",
    $$Request: {
      name: UpdateEmploymentEventRequest.name,
      make: UpdateEmploymentEventRequest.make,
      from_proto: UpdateEmploymentEventRequest.from_proto,
      from_proto_exn: UpdateEmploymentEventRequest.from_proto_exn,
      to_proto: UpdateEmploymentEventRequest.to_proto,
      to_proto$p: UpdateEmploymentEventRequest.to_proto$p,
      merge: UpdateEmploymentEventRequest.merge,
      to_json: UpdateEmploymentEventRequest.to_json,
      from_json_exn: UpdateEmploymentEventRequest.from_json_exn,
      from_json: UpdateEmploymentEventRequest.from_json
    },
    $$Response: {
      name: UpdateEmploymentEventResponse.name,
      make: UpdateEmploymentEventResponse.make,
      from_proto: UpdateEmploymentEventResponse.from_proto,
      from_proto_exn: UpdateEmploymentEventResponse.from_proto_exn,
      to_proto: UpdateEmploymentEventResponse.to_proto,
      to_proto$p: UpdateEmploymentEventResponse.to_proto$p,
      merge: UpdateEmploymentEventResponse.merge,
      to_json: UpdateEmploymentEventResponse.to_json,
      from_json_exn: UpdateEmploymentEventResponse.from_json_exn,
      from_json: UpdateEmploymentEventResponse.from_json
    }
  },
  updateEmploymentEvent: updateEmploymentEvent
};

const V1alpha1 = {
  GetEmploymentEventRequest: GetEmploymentEventRequest,
  GetEmploymentEventResponse: GetEmploymentEventResponse,
  ListEmploymentEventsRequest: ListEmploymentEventsRequest,
  ListEmploymentEventsResponse: ListEmploymentEventsResponse,
  CreateEmploymentEventRequest: CreateEmploymentEventRequest,
  CreateEmploymentEventResponse: CreateEmploymentEventResponse,
  UpdateEmploymentEventRequest: UpdateEmploymentEventRequest,
  UpdateEmploymentEventResponse: UpdateEmploymentEventResponse,
  EmploymentService: V1alpha1_EmploymentService
};

const Hrm = {
  V1alpha1: V1alpha1
};

const Payroll = {
  Hrm: Hrm
};

const Buhta = {
  Payroll: Payroll
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetEmploymentEventRequest Not a pure module */
